export function toMs(value) {
  if (!value) return 0;
  if (typeof value === "number") return value;
  if (typeof value.toDate === "function") return value.toDate().getTime();
  if (value._seconds != null) return value._seconds * 1000;
  if (value.seconds != null) return value.seconds * 1000;
  const parsed = new Date(value).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function toDate(value) {
  const ms = toMs(value);
  return ms ? new Date(ms) : null;
}
